import { environment as testEnvironment } from './environment.test';

export const environment = {
  ...testEnvironment,
  api: {
    url: 'https://api-cidadaodigital-bugfix.test.betha.cloud/api',
  },
};
